var map = {
	"./The Art of Avatar Frontiers of Pandora - Digital Artbook - EN - 4K.zip": 2551,
	"./The Art of Avatar Frontiers of Pandora - Digital Artbook - EN - HD.pdf": 5899,
	"./The Art of Avatar Frontiers of Pandora - Digital Artbook - EN - LD.pdf": 1479
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8701;